<template lang="html">
  <div class="card" :style="{ 'background-image': 'url(' + imageURL + ')' }">
    <span class="text">{{ title }}</span>
  </div>
</template>
<script>
export default {
  props: {
    title: String,
    imageURL: String,
  },
};
</script>
<style lang="css" scoped>
.card {
  width: 175px;
  width: 100%;
  height: 175px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  border-radius: 15px;
  overflow: hidden;
  position: relative;
  border: none;
  cursor: pointer;
}
.card::after {
  content: "";
  position: absolute;
  width: 100%;
  background: rgba(0, 0, 0, 0.3);
  transition: all 0.5s;
  height: 100%;
}
.card::before {
  content: "";
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: all 0.5s;
}
.card:hover::before {
  background: linear-gradient(0deg, rgba(1, 54, 82, 0.8), rgba(1, 54, 82, 0.8)),
    rgba(0, 0, 0, 0.3);
  opacity: 1;
}
.card:hover::after {
  opacity: 0.5;
}

.card .text {
  font-family: "Roboto";
  font-style: normal;
  text-align: center;
  font-weight: 700;
  font-size: 20px;
  line-height: 23px;
  color: #ffffff;
  z-index: 2;
}

@media (max-width: 768px) {
  .card {
    height: 120px;
  }
  .card .text {
    font-size: 14px;
    line-height: 17px;
  }
}
</style>
